module.exports = __webpack_public_path__ + "img/sub30.d16af3ab.jpg";